// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
class FetchBackend {
    constructor(services, backendOptions = {}, i18nextOptions = {}) {
        this.init(services, backendOptions, i18nextOptions);
    }
    init(services, backendOptions) {
        this.options = {
            loadPath: backendOptions.loadPath,
        };
    }
    read(language, namespace, callback) {
        fetch(this.options.loadPath(language, namespace))
            .then((res) => {
            if (!res.ok) {
                throw new Error(`Failed loading with status ${res.status}`);
            }
            return res.json();
        })
            .then((res) => callback(null, res))
            .catch((err) => callback(err, null));
    }
}
FetchBackend.type = 'backend';

export { FetchBackend as default };
//# sourceMappingURL=backend.js.map
